import React from 'react';
import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline';
import AlertConfirmModal from './AlertConfirmModal';

const PublishConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  isPublished,
  itemTitle,
  customMessage,        // نص مخصص (اختياري)
  customNote           // نص تحذيري مخصص (اختياري)
}) => {
  return (
    <AlertConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      icon={isPublished ? EyeOffIcon : EyeIcon}
      iconColorClass={isPublished ? 'text-yellow-500' : 'text-green-500'}
      title={isPublished ? 'تأكيد إلغاء النشر' : 'تأكيد النشر'}
      message={customMessage || `هل أنت متأكد من ${isPublished ? 'إلغاء نشر' : 'نشر'} المحتوى`}
      details={itemTitle}
      note={customNote || (isPublished 
        ? 'لن يكون المحتوى متاحاً للطلاب بعد إلغاء النشر'
        : 'سيكون المحتوى متاحاً للطلاب بعد النشر')}
      confirmText={isPublished ? 'تأكيد إلغاء النشر' : 'تأكيد النشر'}
      cancelText="إلغاء"
      confirmButtonClass={isPublished 
        ? 'bg-yellow-600 hover:bg-yellow-700 dark:bg-yellow-500 dark:hover:bg-yellow-600'
        : 'bg-green-600 hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600'}
      noteClass={isPublished ? 'text-yellow-600 dark:text-yellow-400' : 'text-green-600 dark:text-green-400'}
    />
  );
};

export default PublishConfirmModal;
